export const getTheme = () => {
    return {
        color1: "#00AEEF",
        color2: "#FFFFFF",
        color3: "#1565C0",
        color4: "#9E9E9E",
        color5: "#000000",
        color6: "rgba(255, 255, 255, 0.8)",
        colorAppBarTitle: '#FEFFFF',
        colorMainContainerBackground: '#121212',
        colorExpanded: '#FEFFFF',
        colorCollapsed: '#96979C',
        colorArrowCollapsed: '#00AEEF',
        colorPrimaryButton: '#FEFFFF',
        colorFilterText: '#D0D1D2',
        colorDashboardWidgetText: '#D0D1D2',
        colorDashboardWidgetValue: '#00AEEF',
        colorFormTitle: '#00AEEF',
        colorFormDelimiter: '#00AEEF',
        colorFormLabel: '#96979C',
        colorElementDisabled: '#96979C',
        colorUserEmail: '#D0D1D2',
        colorUsersDivider: '#96979C',
        colorDeleteButton: '#DD0101',
        colorDeleteHoverButton: '#AA0101',
        colorOfferedPrice: '#05D618',
        colorOfferExpired: '#FF4040',
        shadowColor: "rgba(0, 0, 0, 0.15)",
        colorSuccess: "#4CAF50",
        colorFail : "#f44336",
        colorDrawerBackground: '#323334',
        paperColor1: "#323334",
        paperColor2: "#96979C",
        gradientColor1: "#72D9FF",
        gradientColor2: "#4A7DFA"
    }
}